import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

import { forceLogout } from '../../api/axiosInstance';
import { useTranslation } from '../../hooks';
import { COLOR_THEME, PALETTE } from '../../style/colorTheme';
import { importantStyle } from '../../utils';
import { Button } from '../MuiGenerals';

const sx = {
  logoutBtn: {
    minWidth: '64px',
    height: '28px',
    color: COLOR_THEME.Layout.LayoutBar.LogoutBtn.Text,
    backgroundColor: COLOR_THEME.Layout.LayoutBar.LogoutBtn.Background,
    borderRadius: '30px 29.5px 29.5px 30px',
    padding: '.3rem 7px .3rem 10px',
    boxShadow: 'none',
    marginRight: '8px',
    border: '1px solid #474747',
    lineHeight: 'initial',
    svg: {
      transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      color: importantStyle(COLOR_THEME.Layout.LayoutBar.LogoutBtn.Text),
    },

    ':hover': {
      color: importantStyle(PALETTE.PrimaryText),
      svg: {
        color: importantStyle(PALETTE.PrimaryText),
      },
      backgroundColor: COLOR_THEME.Layout.LayoutBar.LogoutBtn.Background,
    },
  },
};

interface IProps {
  isHide?: boolean;
  title?: string;
}

const LogoutButton = (props: IProps) => {
  const { isHide, title } = props;

  const { tc } = useTranslation();

  const logoutFn = () => {
    forceLogout('', { from: 'menu-button' });
  };

  if (isHide) return <></>;

  return (
    <Button
      variant="contained"
      startIcon={<PowerSettingsNewIcon sx={{ marginRight: '-4px' }} />}
      onClick={logoutFn}
      sx={sx.logoutBtn}
    >
      {title || tc('logout')}
    </Button>
  );
};

export default LogoutButton;
